import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

type UseGetUsersByBusinessAreaProps = {
  businessAreaId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetUsersByBusinessArea = ({
  businessAreaId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetUsersByBusinessAreaProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery(
    [
      ...UserKey.BY_BUSINESS_AREA_PAGED(businessAreaId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      usersRepo.getUsersByBusinessArea(
        businessAreaId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
